import React from 'react';
import { Checkbox, Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { IVisibleRows, TVisibleRowField } from './types';
import { EnchancedModal } from 'src/components/Modals';

export const VisibleRows = ({
    fields,
    visibleRows,
    setVisibleRows,
    open,
    setOpen,
}: IVisibleRows) => {
    const { t } = useTranslation();
    const enabledFields = React.useMemo(
        () => fields.filter((f) => !f.disabled),
        [fields]
    );

    const allSelected = enabledFields.every(
        ({ key }) => visibleRows[key]
    );

    const someSelected =
        enabledFields.some(({ key }) => visibleRows[key]) && !allSelected;

    const toggleAll = () => {
        setVisibleRows((prev) => {
            const updated = { ...prev };

            enabledFields.forEach(({ key }) => {
                updated[key] = !allSelected;
            });

            return updated;
        });
    };

    const toggleField = (key: string) => {
        setVisibleRows((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const labelModalTitle: string = t('Buttons.ShowRows');
    const labelShowAll: string = t('Tabs.ShowAll');

    return (
        <EnchancedModal
            open={open}
            setOpen={setOpen}
            title={labelModalTitle}
            maxWidth="xs"
            data-testid="visible-rows-modal"
        >
            <Grid container spacing={2}>
                <Grid
                    item
                    xs={12}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                    }}
                >
                    <Checkbox
                        checked={allSelected}
                        indeterminate={someSelected}
                        onChange={toggleAll}
                        data-testid="show-all-checkbox"
                    />
                    <Typography variant="h6">
                        {labelShowAll}
                    </Typography>
                </Grid>

                {fields.map(
                    ({ key, label, disabled }: TVisibleRowField) => {
                        if (disabled) return null;

                        const labelCheckbox: string = t(label);

                        return (
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                key={key}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10,
                                }}
                            >
                                <Checkbox
                                    checked={!!visibleRows[key]}
                                    onChange={() => toggleField(key)}
                                    data-testid={`visible-row-checkbox-${key}`}
                                />
                                <Typography variant="h6">
                                    {labelCheckbox}
                                </Typography>
                            </Grid>
                        );
                    }
                )}
            </Grid>
        </EnchancedModal>
    );
};
